export default __webpack_public_path__ + "css/genericListItem.bundle.css";